import React from 'react';
import styled from '@emotion/styled';
import { Flex, Heading } from '@qga/roo-ui/components';

import Inclusion from '@/v2/components/ui/Inclusion';

export type RoomTypeProps = {
  name: string;
};

const InclusionContainer = styled.div`
  & > * {
    margin-bottom: 0;
    margin-right: 0;
  }
`;

const RoomType = ({ name }: RoomTypeProps) => {
  return (
    <Flex flexDirection="column" gap="1">
      <Heading.h3 color="text.body" fontWeight="normal" fontSize={'sm'} mb="0">
        Room type:
      </Heading.h3>
      <InclusionContainer>
        <Inclusion inclusion={{ name, code: 'hotel' }} />
      </InclusionContainer>
    </Flex>
  );
};

export default RoomType;
